import { Moment } from 'moment';
import User from '@/shared/models/User';

export interface TransportData {
  byCustomer: boolean;
  address: string | null;
  time: Moment | null;
  driver: User | null;
  note: string | null;
}

export default class TransportDetails {
  address: string | null = null;
  time: Moment | null = null;
  driver: User | null = null;
  note: string | null = null;

  static create(data: TransportData): TransportDetails {
    const details = new TransportDetails();
    details.address = data.address;
    details.time = data.time;
    details.driver = data.driver;
    details.note = data.note;
    return details;
  }

  static forPickupOrDelivery(data: TransportData): TransportDetails | null {
    return data.byCustomer ? null : TransportDetails.create(data);
  }
}
